import {Injectable, Injector} from "@angular/core";
import {CleverreportStoreState} from "../cleverreport.store.module";
import {Store} from "@ngrx/store";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import {Observable} from "rxjs/Observable";
import {AuditEntity} from "./audit.entity";
import {AuditActions} from "./audit.actions";
import {BaseService} from "../base.service";
import {GlobalProvider} from "../../providers/global/global";

@Injectable()
export class AuditService extends BaseService{

  private databaseProvider;

  constructor(private store: Store<CleverreportStoreState>, private injector: Injector, protected globalProvider: GlobalProvider) {
    super(globalProvider);
    setTimeout(() => {
      this.databaseProvider = injector.get(DataProvider);
    })
  }

  addAll(audits: Array<AuditEntity>, synced: boolean = true): void {
    if (!synced) {
      for (let audit of audits) {
        if (!audit.hasOwnProperty('_id')) {
          this.databaseProvider.createDocumentWithoutInit(audit)
            .then((audit: AuditEntity) => {
              this.store.dispatch(AuditActions.add(audit));
            });
        }
      }
    } else {
      this.store.dispatch(AuditActions.addAll(audits));
    }
  }

  add(audit: AuditEntity, synced: boolean = true): Promise<AuditEntity> {
    return new Promise((resolve, reject) => {
      if (!synced) {
        this.databaseProvider.createDocumentWithoutInit(audit)
          .then((audit: AuditEntity) => {
            this.store.dispatch(AuditActions.set(audit));
            resolve(audit);
          }, () => {
            reject();
          });
      } else {
        this.store.dispatch(AuditActions.add(audit));
        resolve(audit);
      }
    });
  }

  set(audit: AuditEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.updateDocument(audit)
        .then((audit: AuditEntity) => {
          this.store.dispatch(AuditActions.set(audit));
        });
    } else {
      this.store.dispatch(AuditActions.set(audit));
    }
  }

  remove(audit: AuditEntity, synced: boolean = true): void {
    if (!synced) {
      this.databaseProvider.softDeleteDocument(audit)
        .then(() => {
          this.store.dispatch(AuditActions.remove(audit._id));
        });
    } else {
      this.store.dispatch(AuditActions.remove(audit._id));
    }
  }

  getById(id: string): Observable<AuditEntity> {
    return this.store.select('audits').map((audits: Array<AuditEntity>) => {
      return audits.find((audit: AuditEntity) => {
        return audit._id === id;
      });
    });
  }

  getAll(): Observable<Array<AuditEntity>> {
    return this.store.select('audits').map((audits: Array<AuditEntity>) => {
      return audits
        .filter((audit: AuditEntity) => {
          return !audit.hasOwnProperty('_deleted') && (!audit.hasOwnProperty('deleted') || !audit.deleted);
        })
    });
  }

  getAllByCustomerId(customerId: string): Observable<Array<AuditEntity>> {
    return this.getAll()
      .map((audits: Array<AuditEntity>) => {
        return audits.filter((audit: AuditEntity) => {
          return audit.customerId === customerId;
        })
      })
  }

  getAllCustomerIdsOfAllAudits(): Observable<Array<string>> {
    return this.getAll()
      .map((audits: Array<AuditEntity>) => {
        let _customerIds: Array<string> = [];
        for(let audit of audits){
          if(_customerIds.indexOf(audit.customerId) === -1){
            _customerIds.push(audit.customerId);
          }
        }
        return _customerIds;
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/audit/audit.service.ts